import httpCommon from "./http-common";

export class OffersService {
    public static async getOffer(id: string): Promise<App.FullOffer> {
        //offers/{id}?fields=offer_id,customer_company_id,recipient_id,number_of_facilities,price,notes,status_code,expires_at
        const response = await httpCommon.get(`/offers/${id}`);
        const data = await response.data;
        return data.offer;
    }
    public static async getOffers(token: string): Promise<App.Offer> {
        //offers/{id}?fields=offer_id,customer_company_id,recipient_id,number_of_facilities,price,notes,status_code,expires_at
        httpCommon.defaults.headers.common.Authorization = `Bearer ${token}`;
        const response = await httpCommon.get(`/offers`);
        return await response.data;
    }

    public static async postProfile(profile: App.MinimalFacilityProfile) {
        // /v4/d411_ids/{id}
        const response = await httpCommon.post(`/d411_ids`, profile);
        return await response.data;
    }

    public static async acceptQuote(quoteId: string) {
        const response = await httpCommon.get(`/accept_quote?quote_id=${quoteId}`);
        return await response.data;
    }
}